type TProp = {
  [key: string]: unknown;
};

export type TDispatcher = {
  track(name: string, props: TProp): void;
};

export const NoopDispatcher = {
  track() {
    // do nothing
  },
};
